import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";
import { Suspense, lazy } from "react";

import Navigation from "./components/highschool/Navigation";
import Footer from "./components/highschool/Footer";
import { CommonLoading } from "./components/Loading/Loading";

const LiveNow = lazy(() => import("./pages/highschool/LiveNow/LiveNow"));
const About = lazy(() => import("./pages/highschool/About/About"));
const Login = lazy(() => import("./pages/highschool/Login/Login"));
const OrgCreation = lazy(() => import("./pages/highschool/OrganizationCreation/OrganizationCreation"));
const DualMeets = lazy(() => import("./pages/highschool/DualMeets/DualMeets"));
const TeamList = lazy(() => import("./pages/highschool/TeamList/TeamList"));
const TeamDetail = lazy(() => import("./pages/highschool/TeamDetail/TeamDetail"));
const OrganizationList = lazy(() => import("./pages/highschool/OrganizationList/OrganizationList"));
const OrganizationDetail = lazy(() => import("./pages/highschool/OrganizationDetail/OrganizationDetail"));
const RosterEditor = lazy(() => import("./pages/highschool/RosterEditor/RosterEditor"));
const DualMeetCreation = lazy(() => import("./pages/highschool/DualMeetCreation/DualMeetCreation"));
const DualMeetInfo = lazy(() => import("./pages/highschool/DualMeetInfo/DualMeetInfo"));
const DualMeetScorer = lazy(() => import("./pages/highschool/DualMeetScorer/DualMeetScorer"));
const FencerInfo = lazy(() => import("./pages/highschool/FencerInfo/FencerInfo"));
const SuperadminPage = lazy(() => import("./pages/highschool/SuperadminPage/SuperadminPage"));
const PrivacyPolicy = lazy(() => import("./pages/highschool/PrivacyPolicy/PrivacyPolicy"));
const Rankings = lazy(() => import("./pages/highschool/Rankings/Rankings"));
const DualMeetManualScorer = lazy(() => import("./pages/highschool/DualMeetManualScorer/DualMeetManualScorer"));
const PoolManualScorer = lazy(() => import("./pages/highschool/PoolManualScorer/PoolManualScorer"));
const DualMeetDisputer = lazy(() => import("./pages/highschool/DualMeetDisputer/DualMeetDisputer"));
const ErrorPage = lazy(() => import("./pages/highschool/NotFound/NotFound"));

import "./Home.css";

const darkTheme = createTheme({
    palette: {
        mode: "dark"
    },
    components: {
        MuiCardHeader: {
            defaultProps: {
                titleTypographyProps: {
                    fontFamily: "Lexend Deca",
                    fontWeight: 500
                },
                sx: {
                    background: theme => theme.palette.secondary.dark
                }
            }
        }
    }
});

const Home = () => {
    return (
        <ThemeProvider theme={darkTheme}>
            <CssBaseline />
            <Router basename={process.env.PUBLIC_URL}>
                <Navigation />
                <Suspense fallback={<CommonLoading />}>
                    <Switch>
                        <Route path="/" exact render={() => <LiveNow />} />
                        <Route path="/about" exact render={() => <About />} />
                        <Route path="/privacy" exact render={() => <PrivacyPolicy />} />
                        <Route path="/login" exact render={() => <Login />} />
                        <Route path="/createDualMeet" exact render={() => <DualMeetCreation />} />
                        <Route path="/createSchool" exact render={() => <OrgCreation />} />
                        <Route path="/dualMeets" exact render={() => <DualMeets />} />
                        <Route path="/meet/:id" exact render={() => <DualMeetInfo />} />
                        <Route path="/dualMeetScorer/:id" render={() => <DualMeetScorer />} />
                        <Route path="/dual-meet-manual-scorer/:id" render={() => <DualMeetManualScorer />} />
                        <Route path="/pool-manual-scorer/:id" render={() => <PoolManualScorer />} />
                        <Route path="/disputes/:meetId/:id" render={() => <DualMeetDisputer />} />
                        <Route path="/schoolList" exact render={() => <OrganizationList />} />
                        <Route path="/school/:id" exact render={() => <OrganizationDetail />} />
                        <Route path="/teamList" exact render={() => <TeamList />} />
                        <Route path="/team/:id" exact render={() => <TeamDetail />} />
                        <Route path="/rosterEditor/:teamId" exact render={() => <RosterEditor />} />
                        <Route path="/fencer/:id" exact render={() => <FencerInfo />} />
                        <Route path="/superadminPage" exact render={() => <SuperadminPage />} />
                        <Route path="/rankings" exact render={() => <Rankings />} />
                        <Route path="*" render={() => <ErrorPage code={404} message="Page not found." />} />
                    </Switch>
                </Suspense>
                <Footer />
            </Router>
        </ThemeProvider>
    );
};

export default Home;
